import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

export const radioGroupClasses = 'grid gap-2';

export const radioGroupItemClasses = cn(
  'peer aspect-square size-4 rounded-full border border-border-selected text-text-primary',
  focusRing,
  'disabled:cursor-not-allowed disabled:opacity-50'
);

export const radioGroupIndicatorClasses = 'flex items-center justify-center';

export const radioGroupItemIconClasses = 'size-2.5 fill-current text-current';
